import { ArrowUpRight } from "lucide-react";
import { SectionHead } from "@/components/SectionHead";
import { useLang } from "@/LanguageContext";
import { SERVICES } from "@/data/site";

export const Services = () => {
  const { t, tr } = useLang();
  return (
  <section id="services" data-testid="services-section" className="border-b border-steel-700 py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
      <SectionHead
        label={t.services.label}
        title={t.services.title}
        sub={t.services.sub}
        testid="services-head"
      />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s) => (
          <a
            key={s.id}
            href="#quote"
            data-testid={`service-card-${s.id}`}
            className={`group relative flex min-h-[300px] flex-col justify-end overflow-hidden rounded-sm border border-steel-700 p-6 transition-colors duration-300 hover:border-forge ${s.span}`}
          >
            <img
              src={s.image}
              alt={tr(s, "title")}
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover opacity-45 transition-[opacity,transform] duration-500 group-hover:opacity-60 group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-steel-950 via-steel-950/80 to-steel-950/25" />
            {s.featured && (
              <span className="absolute right-4 top-4 z-10 rounded-sm bg-forge px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.18em] text-white">
                {t.services.badge}
              </span>
            )}
            <div className="relative z-10">
              <h3 className="flex items-start gap-2 font-head text-2xl font-bold uppercase tracking-wide text-steel-50 sm:text-3xl">
                {tr(s, "title")}
                <ArrowUpRight
                  size={22}
                  className="mt-1 shrink-0 text-forge-light transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </h3>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-steel-400 sm:text-base">{tr(s, "blurb")}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
  );
};
